// extracted by mini-css-extract-plugin
export var actionsRow = "_2g-8";
export var actionsRowEnd = "_2g-9";
export var changeMerchantBtn = "_2g-x";
export var changeMerchantIcon = "_2g-y";
export var checkbox = "_2g-1b";
export var divider = "_2g-1c";
export var errorText = "_2g-1d";
export var exitModalActionBtn = "_2g-a";
export var exitModalActionBtnPrimary = "_2g-b";
export var exitModalRoot = "_2g-0";
export var fieldCard = "_2g-10";
export var fieldChevron = "_2g-18";
export var fieldControl = "_2g-17";
export var fieldIcon = "_2g-13";
export var fieldIconWrap = "_2g-12";
export var fieldInfoIcon = "_2g-16";
export var fieldInfoIconWrap = "_2g-15";
export var fieldLabelBlock = "_2g-11";
export var fieldList = "_2g-z";
export var fieldTitle = "_2g-14";
export var modalContentBody = "_2g-7";
export var modalHeaderImage = "_2g-2";
export var modalImageLabel = "_2g-4";
export var modalImageOverlay = "_2g-3";
export var modalImageSubheading = "_2g-6";
export var modalImageTitle = "_2g-5";
export var modalImageWrapper = "_2g-1";
export var noFieldsHint = "_2g-1e";
export var numberInput = "_2g-19";
export var numberPrefix = "_2g-1a";
export var primaryActionBtn = "_2g-c";
export var primaryActionLabel = "_2g-d";
export var primaryActionLabelHidden = "_2g-e";
export var primaryActionSpin = "_2g-g";
export var primaryActionSpinner = "_2g-f";
export var searchContainer = "_2g-h";
export var searchIcon = "_2g-i";
export var searchInput = "_2g-j";
export var selectedTeamCard = "_2g-s";
export var selectedTeamName = "_2g-v";
export var selectedTeamNameRow = "_2g-u";
export var selectedTeamSubtitle = "_2g-w";
export var selectedTeamText = "_2g-t";
export var teamResultAvatar = "_2g-n";
export var teamResultAvatarFallback = "_2g-o";
export var teamResultEmpty = "_2g-m";
export var teamResultList = "_2g-k";
export var teamResultName = "_2g-q";
export var teamResultRow = "_2g-l";
export var teamResultSubtitle = "_2g-r";
export var teamResultText = "_2g-p";